module.exports = __webpack_public_path__ + "static/media/search_docs.e6e27cca.jpg";